/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import Filter, { FilterableProps } from '../Filter'
import { handleChangeEvent } from '../../../../client/js/lib/form'
import { Checkbox } from '@mantine/core'

function MissingFilesFilter (props: FilterableProps) {
  const { onChange, value } = props
  const intl = useIntl()
  return (
    <Filter>
      <Checkbox
        checked={value === 'true'}
        id="missing_files"
        label={intl.formatMessage({
          id: 'missing_files',
          defaultMessage: 'Fichiers manquant'
        })}
        name="missingFiles"
        onChange={handleChangeEvent(onChange)}
        value="true"
      />
    </Filter>
  )
}

export default MissingFilesFilter
